module.exports = __webpack_public_path__ + "img/num3.3f810b24.jpg";